import jsonata from 'jsonata';
import { Action } from '../model/rule-engine.model';
import { AbstractAction } from './abstract-column-action';

/**
 * Based on params definition (jsonata expression) evaluates and produces an outcome related to
 * defined generic type T
 */
export class JsonataAction<T> extends AbstractAction<T> implements Action<T> {
  readonly type = 'jsonataAction';
  params: string;

  constructor(options: string | Pick<Action<T>, 'params'>) {
    super(typeof options === 'string' ? { params: options } : options);
  }

  /**
   * Uses jsonata to produce an outcome out of facts of the same type
   * @param fact
   * @returns
   */
  apply(fact: T): Partial<T> {
    return jsonata(this.params).evaluate(fact) as unknown as Partial<T>;
  }
}
